<template>
  <div>
    <NuxtLazyHydrate when-idle>
      <NuxtLoadingIndicator color="#4ab5bd" :throttle="0" />
    </NuxtLazyHydrate>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup lang="ts">
import { useCheckForAppUpdates } from '~/composables/useCheckForAppUpdates'
import { useAffiliateTracking } from '~/composables/useAffiliateTracking'
import { useVwoScript } from '~/composables/useVwoScript'

const { checkForAppUpdates } = useCheckForAppUpdates()
// Initialize affiliate tracking
useAffiliateTracking()
// Initialize VWO A/B testing (only in production, excludes embedded/widgets/booking solution)
useVwoScript()

const handlePageShow = (evt: PageTransitionEvent) => {
  if (evt.persisted) {
    setTimeout(function () {
      window.location.reload()
    }, 10)
  }
}

onMounted(() => {
  usePollingWhenTabActive(checkForAppUpdates, 60 * 60 * 1000)
  window.addEventListener('pageshow', handlePageShow, false)
})

onUnmounted(() => {
  window.removeEventListener('pageshow', handlePageShow, false)
})
</script>
